import { render, staticRenderFns } from "./roleDetail.vue?vue&type=template&id=6dfbfd8e&scoped=true"
import script from "./roleDetail.vue?vue&type=script&lang=js"
export * from "./roleDetail.vue?vue&type=script&lang=js"
import style0 from "./roleDetail.vue?vue&type=style&index=0&id=6dfbfd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfbfd8e",
  null
  
)

export default component.exports